import { render, staticRenderFns } from "./info_card.vue?vue&type=template&id=24e9106b&scoped=true&"
import script from "./info_card.vue?vue&type=script&lang=js&"
export * from "./info_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9106b",
  null
  
)

export default component.exports